<template>
  <div class="container mx-auto h-full py-5">
    <el-row :gutter="15">
      <el-col :span="24">
        <el-tabs v-model="activeName">
          <el-tab-pane
            :label="`Pendientes (${pending.hours} acciones)`"
            name="pending"
          >
            <el-row :gutter="15" class="flex items-center h-8">
              <el-col :span="12">
                <span class="font-semibold mr-2">SELECCIONADOS:</span>
                0
              </el-col>
              <el-col :span="12" class="flex justify-end">
                <el-button
                  type="primary"
                  size="small"
                  @click="approveSelected(selected)"
                  >Aprobar seleccionadas</el-button
                >
                <el-button
                  type="danger"
                  size="small"
                  @click="rejectSelected(selected)"
                  >Rechazar seleccionadas</el-button
                >
              </el-col>
            </el-row>
            <el-row :gutter="15">
              <el-col :span="24">
                <el-table
                  ref="opending"
                  :data="opending"
                  row-key="id"
                  stripe
                  size="mini"
                  @select-all="selectAll"
                  @select="select"
                >
                  <el-table-column type="selection" min-width="40" />
                  <el-table-column label="Nombre completo" min-width="280">
                    <template slot-scope="scope">
                      <span
                        >{{ scope.row.name1 }} {{ scope.row.name2 }}
                        {{ scope.row.lastname1 }}
                        {{ scope.row.lastname2 }}</span
                      >
                    </template>
                  </el-table-column>
                  <el-table-column label="Salario" min-width="68" align="right">
                    <template slot-scope="scope">
                      <span>{{ scope.row.currentSalary | formatMoney }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="Salario/h"
                    min-width="68"
                    align="right"
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.hourlySalary | formatMoney }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="paysheet.code"
                    label="Nómina"
                    min-width="75"
                  />
                  <el-table-column label="" min-width="667" />
                  <!-- <el-table-column
                    prop="hours"
                    label="No. Horas"
                    min-width="72"
                    align="center"
                  />
                  <el-table-column
                    prop="hours"
                    label="Total $"
                    min-width="75"
                    align="right"
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.cost | formatMoney }}</span></template
                    ></el-table-column
                  >
                  <el-table-column
                    prop="overtimeType.name"
                    label="Unidad"
                    min-width="120"
                  />
                  <el-table-column label="Fecha" min-width="80">
                    <template slot-scope="scope">
                      <span>{{ scope.row.date | formatDate }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="comment"
                    label="Observaciones"
                    min-width="320"
                  /> -->
                </el-table>
              </el-col>
            </el-row>
          </el-tab-pane>
          <!-- <el-tab-pane
            :label="`Aprobadas (${approved.hours} horas)`"
            name="approved"
          >
            <el-row :gutter="15" class="flex items-center h-8">
              <el-col :span="12">
                <span class="font-semibold mr-2">SELECCIONADOS:</span>
                0
              </el-col>
              <el-col :span="12" class="flex justify-end">
                <el-button
                  type="danger"
                  size="small"
                  @click="rejectSelected(selected)"
                  >Rechazar seleccionadas</el-button
                >
              </el-col>
            </el-row>
            <el-row :gutter="15">
              <el-col :span="24">
                <el-table
                  ref="oapproved"
                  :data="oapproved"
                  row-key="id"
                  stripe
                  size="mini"
                  @select-all="selectAll"
                  @select="select"
                >
                  <el-table-column type="selection" min-width="40" />
                  <el-table-column label="Nombre completo" min-width="280">
                    <template slot-scope="scope">
                      <span
                        >{{ scope.row.name1 }} {{ scope.row.name2 }}
                        {{ scope.row.lastname1 }}
                        {{ scope.row.lastname2 }}</span
                      >
                    </template>
                  </el-table-column>
                  <el-table-column label="Salario" min-width="68" align="right">
                    <template slot-scope="scope">
                      <span>{{ scope.row.currentSalary | formatMoney }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="Salario/h"
                    min-width="68"
                    align="right"
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.hourlySalary | formatMoney }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="paysheet.code"
                    label="Nómina"
                    min-width="75"
                  />
                  <el-table-column
                    prop="hours"
                    label="No. Horas"
                    min-width="72"
                    align="center"
                  />
                  <el-table-column
                    prop="hours"
                    label="Total $"
                    min-width="75"
                    align="right"
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.cost | formatMoney }}</span></template
                    ></el-table-column
                  >
                  <el-table-column
                    prop="overtimeType.name"
                    label="Unidad"
                    min-width="120"
                  />
                  <el-table-column label="Fecha" min-width="80">
                    <template slot-scope="scope">
                      <span>{{ scope.row.date | formatDate }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="comment"
                    label="Observaciones"
                    min-width="320"
                  />
                </el-table>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane
            :label="`Rechazadas (${rejected.hours} horas)`"
            name="rejected"
          >
            <el-row :gutter="15" class="flex items-center h-8">
              <el-col :span="12">
                <span class="font-semibold mr-2">SELECCIONADOS:</span>
                0
              </el-col>
              <el-col :span="12" class="flex justify-end">
                <el-button
                  type="primary"
                  size="small"
                  @click="approveSelected(selected)"
                  >Aprobar seleccionadas</el-button
                >
              </el-col>
            </el-row>
            <el-row :gutter="15">
              <el-col :span="24">
                <el-table
                  ref="orejected"
                  :data="orejected"
                  row-key="id"
                  stripe
                  size="mini"
                  @select-all="selectAll"
                  @select="select"
                >
                  <el-table-column type="selection" min-width="40" />
                  <el-table-column label="Nombre completo" min-width="280">
                    <template slot-scope="scope">
                      <span
                        >{{ scope.row.name1 }} {{ scope.row.name2 }}
                        {{ scope.row.lastname1 }}
                        {{ scope.row.lastname2 }}</span
                      >
                    </template>
                  </el-table-column>
                  <el-table-column label="Salario" min-width="68" align="right">
                    <template slot-scope="scope">
                      <span>{{ scope.row.currentSalary | formatMoney }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="Salario/h"
                    min-width="68"
                    align="right"
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.hourlySalary | formatMoney }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="paysheet.code"
                    label="Nómina"
                    min-width="75"
                  />
                  <el-table-column
                    prop="hours"
                    label="No. Horas"
                    min-width="72"
                    align="center"
                  />
                  <el-table-column
                    prop="hours"
                    label="Total $"
                    min-width="75"
                    align="right"
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.cost | formatMoney }}</span></template
                    ></el-table-column
                  >
                  <el-table-column
                    prop="overtimeType.name"
                    label="Unidad"
                    min-width="120"
                  />
                  <el-table-column label="Fecha" min-width="80">
                    <template slot-scope="scope">
                      <span>{{ scope.row.date | formatDate }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="comment"
                    label="Observaciones"
                    min-width="320"
                  />
                </el-table>
              </el-col>
            </el-row>
          </el-tab-pane> -->
        </el-tabs>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import axios from "axios";
import * as R from "ramda";

export default {
  name: "ActionsPaysheet",
  beforeRouteEnter(to, from, next) {
    axios
      .post("/", {
        query: `{
          employeePersonalActions (where: { completed: false, approved: null }) {
            id
            employee { id code name1 name2 lastname1 lastname2 currentSalary department { parentDepartment { id } } }
            personalAction { name, affectsMethod }
            value
            quincenaUno
            quincenaDos
            completed
            isRecurrent
            approved
          }
        }`,
      })
      .then((res) => {
        const { data, errors } = res.data;
        if (R.isNil(errors)) {
          next((vm) =>
            vm.setData({
              actions: data.employeePersonalActions,
            })
          );
        } else {
          next(new Error(errors[0].message));
        }
      });
  },
  data() {
    return {
      activeName: "pending",
      rawActions: [],
      selected: [],
    };
  },
  methods: {
    setData({ actions }) {
      this.rawActions = actions;
    },
    selectAll(data) {
      for (const s of this.selected) {
        this.$refs[`o${this.activeName}`].toggleRowSelection(s, false);
      }
      const selected = [];
      for (const row of data) {
        if (row.hasOwnProperty("children")) {
          for (const ch of row.children) {
            selected.push(ch);
          }
        }
      }
      for (const s of selected) {
        this.$refs[`o${this.activeName}`].toggleRowSelection(s, true);
      }
      this.selected = selected;
    },
    select(data, row) {
      if (row.hasOwnProperty("children")) {
        for (const ch of row.children) {
          if (this.selected.includes(ch)) {
            this.selected = this.selected.filter((s) => s != ch);
          } else {
            this.selected.push(ch);
          }
        }
      } else {
        if (this.selected.includes(row)) {
          this.selected = this.selected.filter((s) => s != row);
        } else {
          this.selected.push(row);
        }
      }
    },
    approveSelected(selected) {
      if (selected.length == 0) {
        return this.$notify({
          title: "Error",
          message: "Debes seleccionar horas para poder aprobar.",
          type: "error",
          duration: 3500,
        });
      }

      this.$confirm(
        `¿Estas seguro que deseas aprobar las horas seleccionadas?`,
        "Confirmación",
        {
          confirmButtonText: `Si, aprobar`,
          cancelButtonText: "Cancelar",
          type: "warning",
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              instance.confirmButtonLoading = true;
              instance.confirmButtonText = "Procesando...";
              let ids = "";
              for (const el of selected) {
                if (!Array.isArray(el)) {
                  ids += `{id: ${el.id}},`;
                }
              }
              axios
                .post("/", {
                  query: `mutation { 
                      overtimeUpdateStatus(where: [${ids}], status: true) {
                        id
                        employee { id code name1 name2 lastname1 lastname2 currentSalary department { parentDepartment { id } } }
                        hours
                        overtimeType { name factor }
                        date
                        paysheet { id paysheetType { id } code startDate endDate }
                        comment
                        status
                        hourlySalary
                      }
                    }`,
                })
                .then((res) => {
                  const { data, errors } = res.data;
                  if (R.isNil(errors)) {
                    this.rawOvertimes = data.overtimeUpdateStatus;
                  }
                  this.$notify({
                    title: R.isNil(errors) ? "Éxito" : "Error",
                    message: R.isNil(errors)
                      ? `Se han aprobado las horas extras seleccionadas. Ahora puedes verlas en la pestaña de Aprobadas.`
                      : errors[0].message,
                    type: R.isNil(errors) ? "success" : "error",
                    duration: 3500,
                  });
                  instance.confirmButtonLoading = false;
                  instance.confirmButtonText = `Si, aprobar`;
                  done();
                });
            } else {
              done();
            }
          },
        }
      );
    },
    rejectSelected(selected) {
      if (selected.length == 0) {
        return this.$notify({
          title: "Error",
          message: "Debes seleccionar horas para poder rechazar.",
          type: "error",
          duration: 3500,
        });
      }

      this.$confirm(
        `¿Estas seguro que deseas rechazar las horas seleccionadas?`,
        "Confirmación",
        {
          confirmButtonText: `Si, rechazar`,
          cancelButtonText: "Cancelar",
          type: "warning",
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              instance.confirmButtonLoading = true;
              instance.confirmButtonText = "Procesando...";
              let ids = "";
              for (const el of selected) {
                if (!Array.isArray(el)) {
                  ids += `{id: ${el.id}},`;
                }
              }
              axios
                .post("/", {
                  query: `mutation { 
                      overtimeUpdateStatus(where: [${ids}], status: false) {
                        id
                        employee { id code name1 name2 lastname1 lastname2 currentSalary department { parentDepartment { id } } }
                        hours
                        overtimeType { name factor }
                        date
                        paysheet { id paysheetType { id } code startDate endDate }
                        comment
                        status
                        hourlySalary
                      }
                    }`,
                })
                .then((res) => {
                  const { data, errors } = res.data;
                  if (R.isNil(errors)) {
                    this.rawOvertimes = data.overtimeUpdateStatus;
                  }
                  this.$notify({
                    title: R.isNil(errors) ? "Éxito" : "Error",
                    message: R.isNil(errors)
                      ? `Se han rechazado las horas extras seleccionadas. Ahora puedes verlas en la pestaña de Rechazadas.`
                      : errors[0].message,
                    type: R.isNil(errors) ? "success" : "error",
                    duration: 3500,
                  });
                  instance.confirmButtonLoading = false;
                  instance.confirmButtonText = `Si, rechazar`;
                  done();
                });
            } else {
              done();
            }
          },
        }
      );
    },
  },
  computed: {
    actions() {
      return this.rawActions.map((e) => {
        return {
          ...e,
          fullName: `${e.name1} ${e.name2} ${e.lastname1} ${e.lastname2}`,
        };
      });
    },
    opending() {
      return [];
      // let employees = [];
      // for (const overtime of this.overtimes.filter((o) => o.status === null)) {
      //   const found = employees.find((e) => e.id == overtime.employee.id);
      //   if (found) {
      //     delete overtime.employee;
      //     delete overtime.hourlySalary;
      //     const cost =
      //       found.hourlySalary * overtime.overtimeType.factor * overtime.hours;
      //     found.hours = found.hours + overtime.hours;
      //     found.cost = found.cost + cost;
      //     found.children.push({
      //       ...overtime,
      //       cost,
      //       currentSalary: null,
      //       hourlySalary: null,
      //     });
      //   } else {
      //     const cost =
      //       overtime.hourlySalary *
      //       overtime.overtimeType.factor *
      //       overtime.hours;
      //     const obj = {
      //       hours: overtime.hours,
      //       paysheet: overtime.paysheet,
      //       comment: "",
      //       data: "",
      //       ...overtime.employee,
      //       cost,
      //       hourlySalary: overtime.hourlySalary,
      //     };
      //     delete overtime.employee;
      //     delete overtime.hourlySalary;

      //     obj["children"] = [
      //       {
      //         ...overtime,
      //         cost,
      //         currentSalary: null,
      //         hourlySalary: null,
      //       },
      //     ];
      //     employees.push(obj);
      //   }
      // }
      // return employees;
    },
    // oapproved() {
    //   let employees = [];
    //   for (const overtime of this.overtimes.filter((o) => o.status)) {
    //     const found = employees.find((e) => e.id == overtime.employee.id);
    //     if (found) {
    //       delete overtime.employee;
    //       delete overtime.hourlySalary;
    //       const cost =
    //         found.hourlySalary * overtime.overtimeType.factor * overtime.hours;
    //       found.hours = found.hours + overtime.hours;
    //       found.cost = found.cost + cost;
    //       found.children.push({
    //         ...overtime,
    //         cost,
    //         currentSalary: null,
    //         hourlySalary: null,
    //       });
    //     } else {
    //       const cost =
    //         overtime.hourlySalary *
    //         overtime.overtimeType.factor *
    //         overtime.hours;
    //       const obj = {
    //         hours: overtime.hours,
    //         paysheet: overtime.paysheet,
    //         comment: "",
    //         data: "",
    //         ...overtime.employee,
    //         cost,
    //         hourlySalary: overtime.hourlySalary,
    //       };
    //       delete overtime.employee;
    //       delete overtime.hourlySalary;

    //       obj["children"] = [
    //         {
    //           ...overtime,
    //           cost,
    //           currentSalary: null,
    //           hourlySalary: null,
    //         },
    //       ];
    //       employees.push(obj);
    //     }
    //   }
    //   return employees;
    // },
    // orejected() {
    //   let employees = [];
    //   for (const overtime of this.overtimes.filter((o) => o.status === false)) {
    //     const found = employees.find((e) => e.id == overtime.employee.id);
    //     if (found) {
    //       delete overtime.employee;
    //       delete overtime.hourlySalary;
    //       const cost =
    //         found.hourlySalary * overtime.overtimeType.factor * overtime.hours;
    //       found.hours = found.hours + overtime.hours;
    //       found.cost = found.cost + cost;
    //       found.children.push({
    //         ...overtime,
    //         cost,
    //         currentSalary: null,
    //         hourlySalary: null,
    //       });
    //     } else {
    //       const cost =
    //         overtime.hourlySalary *
    //         overtime.overtimeType.factor *
    //         overtime.hours;
    //       const obj = {
    //         hours: overtime.hours,
    //         paysheet: overtime.paysheet,
    //         comment: "",
    //         data: "",
    //         ...overtime.employee,
    //         cost,
    //         hourlySalary: overtime.hourlySalary,
    //       };
    //       delete overtime.employee;
    //       delete overtime.hourlySalary;

    //       obj["children"] = [
    //         {
    //           ...overtime,
    //           cost,
    //           currentSalary: null,
    //           hourlySalary: null,
    //         },
    //       ];
    //       employees.push(obj);
    //     }
    //   }
    //   return employees;
    // },
    pending() {
      return this.actions
        .filter((o) => o.appr === null)
        .reduce(
          (a, b) => {
            return {
              hours: parseFloat(a.hours) + parseFloat(b.hours),
            };
          },
          { hours: 0 }
        );
    },
    // approved() {
    //   return this.overtimes
    //     .filter((o) => o.status)
    //     .reduce(
    //       (a, b) => {
    //         return {
    //           hours: parseFloat(a.hours) + parseFloat(b.hours),
    //         };
    //       },
    //       { hours: 0 }
    //     );
    // },
    // rejected() {
    //   return this.overtimes
    //     .filter((o) => o.status === false)
    //     .reduce(
    //       (a, b) => {
    //         return {
    //           hours: parseFloat(a.hours) + parseFloat(b.hours),
    //         };
    //       },
    //       { hours: 0 }
    //     );
    // },
  },
};
</script>
